import { css } from 'styled-components';
import token from 'styled-token';
import { InputMixin } from './InputMixin';

/** @class AdornmentLeftMixin */
/** @method */
export var AdornmentLeftMixin = function AdornmentLeftMixin(props) {
  return token({
    borderRight: 'Adornment.Right.borderRight',
    borderTopRightRadius: 'Adornment.Right.borderTopRightRadius',
    borderBottomRightRadius: 'Adornment.Right.borderBottomRightRadius'
  }, function (_ref) {
    var _ref$borderRight = _ref.borderRight,
      borderRight = _ref$borderRight === void 0 ? 0 : _ref$borderRight,
      _ref$borderTopRightRa = _ref.borderTopRightRadius,
      borderTopRightRadius = _ref$borderTopRightRa === void 0 ? 0 : _ref$borderTopRightRa,
      _ref$borderBottomRigh = _ref.borderBottomRightRadius,
      borderBottomRightRadius = _ref$borderBottomRigh === void 0 ? 0 : _ref$borderBottomRigh;
    return css(["border-top-right-radius:", "px;border-bottom-right-radius:", "px;border-right:", ";"], borderTopRightRadius, borderBottomRightRadius, borderRight);
  })(props);
};

/** @class AdornmentRightMixin */
/** @method */
export var AdornmentRightMixin = function AdornmentRightMixin(props) {
  return token({
    borderLeft: 'Adornment.Left.borderLeft',
    borderTopLeftRadius: 'Adornment.Left.borderTopLeftRadius',
    borderBottomLeftRadius: 'Adornment.Left.borderBottomLeftRadius'
  }, function (_ref2) {
    var _ref2$borderLeft = _ref2.borderLeft,
      borderLeft = _ref2$borderLeft === void 0 ? 0 : _ref2$borderLeft,
      _ref2$borderTopLeftRa = _ref2.borderTopLeftRadius,
      borderTopLeftRadius = _ref2$borderTopLeftRa === void 0 ? 0 : _ref2$borderTopLeftRa,
      _ref2$borderBottomLef = _ref2.borderBottomLeftRadius,
      borderBottomLeftRadius = _ref2$borderBottomLef === void 0 ? 0 : _ref2$borderBottomLef;
    return css(["border-top-left-radius:", "px;border-bottom-left-radius:", "px;border-left:", ";"], borderTopLeftRadius, borderBottomLeftRadius, borderLeft);
  })(props);
};
var zsgCSS = token('Input.adornmentColor', function (color) {
  return color && "\n        &[disabled] {\n            color: " + color + ";\n        }\n    ";
});

/** @class AdornmentMixin */
/** @method */
export var AdornmentMixin = function AdornmentMixin(props) {
  return token('Input.adornmentColor', function (color) {
    return css(["", " color:", ";width:auto;display:inline-flex;align-items:center;user-select:none;", ""], InputMixin(props), color, zsgCSS(props));
  })(props);
};